import {
  IsEmail,
  IsNotEmpty,
  MinLength,
  IsStrongPassword,
  IsBoolean,
  Equals,
} from 'class-validator';

import { t } from '@app-velocity/i18n';

export class UserRegisterDto {
  @IsEmail(
    {},
    {
      message: t('users:validation.email_is_not_valid'),
    }
  )
  @IsNotEmpty({
    message: t('users:validation.email_cannot_be_empty'),
  })
  email = '';

  @MinLength(8, {
    message: t('users:validation.password_too_short', {
      minLength: 8,
    }),
  })
  @IsStrongPassword(
    {
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
    },
    {
      message: t('users:validation.password_too_weak'),
    }
  )
  @IsNotEmpty({
    message: t('users:validation.password_cannot_be_empty'),
  })
  password = '';

  @IsBoolean()
  @Equals(true, { message: t('users:validation.agreement_is_necessary') })
  acceptedAgreements = false;

  @IsBoolean()
  marketingAccepted = true;
}
